/** Preserve the same account's balance when a partial profile omits credits. */
export function mergeUserCredits(currentUser, incomingUser) {
  const previous = incomingUser?.id && incomingUser.id === currentUser?.id
    ? currentUser.credits || {} : {};
  const incoming = incomingUser?.credits || {};
  return {
    monthlyAllotment: {
      total: 0, used: 0, remaining: 0, resetDate: null,
      ...previous.monthlyAllotment,
      ...incoming.monthlyAllotment,
    },
    purchased: {
      available: 0, paidAvailable: 0,
      ...previous.purchased,
      ...incoming.purchased,
    },
    // Missing is unknown, not an exhausted wallet. An explicit zero wins.
    totalAvailable: incoming.totalAvailable ?? previous.totalAvailable,
    pendingVerificationCredits: incoming.pendingVerificationCredits
      ?? previous.pendingVerificationCredits ?? 0,
  };
}
